import Constants from '../utils/params';

export function handleErrors(response)
{
    if (!response.ok) {
        throw (response);
    }
    return response.json();
}

export function getSurveysByReportId(token, id)
{
    let params = {
        headers: {'Authorization': "bearer " + token}
    };

    return fetch(`${Constants.DOMAIN}/api/survey/report/` + id, params)
        .then(handleErrors)
        .then(res=>res)
        .catch((err)=>{
            return err;
        })
}

export function getSurveyById(token, id)
{
    let params = {
        headers: {'Authorization': "bearer " + token}
    };

    return fetch(`${Constants.DOMAIN}/api/survey/` + id, params)
        .then(handleErrors)
        .then(res=>res)
        .catch((err)=>{
            return err;
        })
}

export function getSurveysTemplates(token)
{
    let params = {
        headers: {'Authorization': "bearer " + token}
    };

    return fetch(`${Constants.DOMAIN}/api/survey/templates`, params)
        .then(handleErrors)
        .then(res=>res)
        .catch((err)=>{
            return err;
        })
}

export function createCopySurvey(token, survey_id, report_id, data)
{
    return fetch(`${Constants.DOMAIN}/api/survey/${survey_id}/${report_id}/create`, {
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': "bearer " + token
        },
        body: JSON.stringify(data)
    }).then(handleErrors)
        .then(res=>res)
        .catch((err)=>{
            return err;
        })
}

export function updateSurveyCopy(token, survey_id, report_id, data)
{
    return fetch(`${Constants.DOMAIN}/api/survey/${survey_id}/${report_id}/update`, {
        method: 'put',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': "bearer " + token
        },
        body: JSON.stringify(data)
    }).then(handleErrors)
        .then(res=>res)
        .catch((err)=>{
            return err;
        })
}

export function removeSurvey(token, id)
{
    return fetch(`${Constants.DOMAIN}/api/survey/` + id, {
        method: 'delete',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': "bearer " + token
        }
    }).then(handleErrors)
        .then(res=>res)
        .catch((err)=>{
            return err;
        })
}

export function updateReportSurvey(token, id, data)
{
    return fetch(`${Constants.DOMAIN}/api/survey/` + id, {
        method: 'put',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': "bearer " + token
        },
        body: JSON.stringify(data)
    }).then(handleErrors)
        .then(res=>res)
        .catch((err)=>{
            return err;
        })
}


// WEBPACK FOOTER //
// ./src/api/survey.js